<template>
  <div>
    <el-input type="textarea" :rows="rows" ref="textarea" v-model="inputValue"></el-input>
  </div>
</template>
<script>

export default {
  props: {
    rows: Number,
    value: String
  },
  data() {
    return {
      // inputValue: this.value
    }
  },
  methods: {
    // updateValue(val) {
    //   var v = val
    //   if (v) {
    //     v = v.trim().replace(/[^\u0000-\u00FF]+/g, '').toUpperCase()
    //     this.inputValue = v
    //     this.$emit('input', v)
    //   }
    // }
  },
  computed: {
    // inputValue() {
    //   var v = this.value.trim().replace(/([^\u0000-\u00FF])/g, '').toUpperCase()
    //   return v
    // }
    inputValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v ? v.toUpperCase() : v)
      }
    }
  }
}

</script>
